// extracted by mini-css-extract-plugin
export default {"Footer":"style_Footer__R+efR","Grid":"style_Grid__cIoIm"};